import { Link } from 'react-router-dom'

import { useCallback, useEffect, useState, useRef } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { AiOutlineSend } from 'react-icons/ai'
import { IoMdThumbsDown, IoMdThumbsUp } from 'react-icons/io'
import getValidationError from '../../../../utils/getValidationErrors'
import TextArea from '../../../../components/Textarea'

import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'

import * as Yup from 'yup'

import history from '../../../../services/history'
import { changeRecentPath } from '../../../../store/modules/recentView/action'

import {
  Container,
  HeaderCard,
  CardBody,
  TitleCard,
  ContentCard,
  HeaderContendCard,
  FooterCard,
  Card,
  DoubtCard,
  AnsweredCard,
  HandsOkNo,
  TextQuestion,
} from './styles'
import { useDispatch } from 'react-redux'
import { DELETE_NOTIFICATION, NEW_MESSAGE_DOUBT } from 'pages/Doubt/services'
import { useGetStudentDoubts } from 'pages/Doubt/hooks/use-get-student-doubts'
import { StudentDoubt } from 'pages/Doubt/types'

const DoubtAnswered = ({ query, number }) => {
  const formRef = useRef<FormHandles>()
  const [doubtsData, setDoubtsData] = useState<StudentDoubt>()
  const dispatch = useDispatch()

  const swrGetStudentDoubts = useGetStudentDoubts(query)
  const data = swrGetStudentDoubts.isLoading ? '' : swrGetStudentDoubts.data

  useEffect(() => {
    DELETE_NOTIFICATION(query)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [DELETE_NOTIFICATION])

  useEffect(() => {
    if (data) {
      setDoubtsData(data)
    }
  }, [data])

  const handleDoubt = useCallback(
    async (data, { reset }) => {
      try {
        formRef.current?.setErrors({})

        const schema = Yup.object().shape({
          questionText: Yup.string().required('Quantidade de caracteres inválida'),
        })
        await schema.validate(data, {
          abortEarly: false,
        })

        doubtsData.dialog.push({
          user: 0,
          answer: data.questionText,
        })

        const newDate = {
          ...doubtsData,
          dialog: doubtsData.dialog,
          status: 0,
        }

        await NEW_MESSAGE_DOUBT(query, newDate)
        setDoubtsData(newDate)
        reset()
      } catch (err) {
        console.error(err)
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationError(err)
          formRef.current?.setErrors(errors)
        }
      }
    },
    [query, doubtsData]
  )

  const handleSendFeedback = useCallback(
    async (event, util) => {
      event.preventDefault()

      if (doubtsData && doubtsData.util !== 0) return
      const newDate = {
        ...doubtsData,
        dialog: doubtsData.dialog,
        util,
      }

      await NEW_MESSAGE_DOUBT(query, newDate)

      setDoubtsData({ ...doubtsData, util: util })
    },
    [query, doubtsData]
  )

  return (
    <Container>
      <HeaderCard>
        <Link to="/duvidas">
          <button>
            <FaArrowLeft size={12} /> Voltar
          </button>
        </Link>
      </HeaderCard>
      <Card>
        <CardBody>
          <TitleCard>
            <div className="header-title">
              <h3>Dúvida # {number}</h3>
              <p>Enviada em {new Date(doubtsData?.createdAt).toLocaleDateString() ?? ''}</p>
            </div>
            <span>
              {doubtsData?.dialog && doubtsData?.dialog.some((item) => item.user === 1)
                ? 'Respondida'
                : ''}
            </span>
          </TitleCard>
          <HeaderContendCard>
            <p>
              <b>{doubtsData?.course?.name}</b>
            </p>
            <p>
              <strong>Módulo: </strong>
              {doubtsData?.studyModule?.subject || doubtsData?.studyModule?.name}
            </p>
            <p>
              <strong>Aula: </strong>
              {doubtsData?.lesson?.heading || doubtsData?.lesson?.name}
            </p>
            <p>
              <strong>Capítulo: </strong>
              {doubtsData?.minimumApprenticeshipUnit?.heading ||
                doubtsData?.minimumApprenticeshipUnit?.name}
            </p>
            <button
              onClick={() => {
                dispatch(changeRecentPath(`/duvidas/${query}/${number}`))

                history.push({
                  pathname: `/course/${doubtsData?.course?._id}/module/${doubtsData?.studyModule?._id}/lesson/${doubtsData?.lesson?._id}/chapter/${doubtsData?.minimumApprenticeshipUnit?._id}`,
                  state: { lessonType: `${doubtsData?.objectType}` },
                })
              }}
            >
              Ir para a aula
            </button>
          </HeaderContendCard>
          <div>
            <hr />
          </div>
          <HeaderContendCard>
            <div>
              <h3 title={doubtsData?.title}>
                {doubtsData?.title?.substr(0, 400)}
                {doubtsData?.title?.length > 400 ? '...' : ''}
              </h3>
            </div>
          </HeaderContendCard>
          <ContentCard className="body">
            {doubtsData &&
              doubtsData.dialog &&
              doubtsData.dialog.map((item, index) =>
                Number(item.user) === 0 ? (
                  <AnsweredCard key={index}>
                    <img
                      src={`https://ui-avatars.com/api/?name=${doubtsData?.student?.name}&=rounded=true&background=ff6600&color=FFF`}
                      alt="Foto Professor"
                      width="40"
                      height="40"
                    />
                    <p>{doubtsData.student?.name}</p>
                    <span className="doubt" dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </AnsweredCard>
                ) : (
                  <DoubtCard>
                    <img
                      src={`https://ui-avatars.com/api/?name=${doubtsData?.professor?.name}&=rounded=true&background=ff6600&color=FFF`}
                      alt="Foto Professor"
                      width="40"
                      height="40"
                    />

                    <p>Prof. {doubtsData.professor?.name}</p>
                    <span className="doubt" dangerouslySetInnerHTML={{ __html: item.answer }} />
                  </DoubtCard>
                )
              )}
          </ContentCard>
          {doubtsData && doubtsData.status === 0 ? (
            <TextQuestion>
              <Form ref={formRef} onSubmit={handleDoubt} autoComplete="false">
                <TextArea
                  name="questionText"
                  placeholder="Digite sua mensagem ..."
                  id="doubt"
                  rows={3}
                  minLength={1}
                />
                <button type="submit">
                  <AiOutlineSend size={35} />
                </button>
              </Form>
            </TextQuestion>
          ) : (
            <FooterCard>
              <h3>A resposta te ajudou?</h3>
              <HandsOkNo util={doubtsData?.util ?? 0}>
                <IoMdThumbsUp
                  onClick={(event) => handleSendFeedback(event, 1)}
                  className={doubtsData && doubtsData.util !== 0 ? 'to-up' : 'to-up clickable'}
                  size={25}
                />
                <hr />
                <IoMdThumbsDown
                  onClick={(event) => handleSendFeedback(event, 2)}
                  className={doubtsData && doubtsData.util !== 0 ? 'to-down' : 'to-down clickable'}
                  size={25}
                />
              </HandsOkNo>
            </FooterCard>
          )}
        </CardBody>
      </Card>
    </Container>
  )
}

export default DoubtAnswered
